import React, { useEffect, useState } from 'react';
import { IInviteService, ITable } from '../../game/model/interfaces';
import { container } from 'tsyringe';
import { useSubject } from '../../../utils/helpers';
import { useHistory } from 'react-router-dom';
import { MAIN_ROUTES } from '../../routing/constants/mainRoutes';

type UseInvitesType = {
  tables: ITable[];
  count: number;
  doNotDisturb: boolean;
  disturbHandle: (e: React.ChangeEvent<HTMLInputElement>) => void;
  joinTable: (table: ITable) => void;
};

export const useInvites = (): UseInvitesType => {
  const history = useHistory();
  const [tables, setTables] = useState<ITable[]>([]);
  const inviteService: IInviteService = container.resolve('inviteService');
  const initialValueDoNotDisturb = inviteService.getDisturbStatus();
  const [doNotDisturb, setDoNotDisturb] = useState(initialValueDoNotDisturb);

  const doNotDisturbHandle = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setDoNotDisturb(e.target.checked);
    inviteService.setDisturbStatus(e.target.checked);
  };

  const joinTable = (table: ITable): void => {
    const tid = table.tid;
    if (inviteService.acceptInvite(tid, false)) {
      history.push(MAIN_ROUTES.game);
    }
  };

  const invites = useSubject(inviteService.onInvitesChange);

  useEffect(() => {
    if (!invites) return;
    const tables = Object.values(invites);
    const notEmptyAndNotFullTables = checkUserOnTable(tables);
    setTables(notEmptyAndNotFullTables);
  }, [invites]);

  return {
    tables,
    count: tables.length,
    doNotDisturb,
    disturbHandle: doNotDisturbHandle,
    joinTable: joinTable,
  };
};

function checkUserOnTable(tables: ITable[]): ITable[] {
  const sortTables: ITable[] = [];

  tables.forEach((table: ITable) => {
    //если оба игрока уже есть, либо никого нет
    if ((table.seats[0] && table.seats[1]) || (!table.seats[0] && !table.seats[1])) {
      return;
    } else {
      sortTables.push(table);
    }
  });
  return sortTables;
}
